
	function StartTrainingPopup(settings){
		this.className = "StartTrainingPopup";

		this.name = "start-training";

		if(!settings) settings = {};

		settings = {
			name: settings.name ? settings.name : null,
			courseTitle: settings.courseTitle ? settings.courseTitle : null,
			courseID: settings.courseID ? settings.courseID : null,
			courseLink: settings.courseLink ? settings.courseLink : null,
			controller: settings.controller ? settings.controller : null,
			//coursesLink: settings.coursesLink ? settings.coursesLink : null,
		};

		//this.$popup = $('.js-page-popup');
		//this.$content = this.$popup.find('.js-content');

		this.data = {
			pages: [
				{
					title: "Choose a person to start training",
					name: "select-team",
					static: true,
					onRender: (e) => {
						const $this = e;
						const $startTrainingLink = $this.find('.js-start-training-link');

						// Skip user selection if provided user details.
						if(settings.name && settings.courseLink || settings.coursesLink){
							return this.nextPage();
						}

						// Append individual course link.
						if(settings.courseLink) $startTrainingLink.attr('data-course-link', settings.courseLink);
						if(settings.courseID) $startTrainingLink.attr('data-course', settings.courseID);

						$startTrainingLink.on('click', Igloo.$d(this, function($this){
							const name = $this.attr('data-name');
							const courseID = $this.attr('data-course');
							const courseLink = $this.attr('data-course-link');

							this.values = {
								name: name,
								courseID: courseID,
								courseLink: courseLink
							};

							this.submit();
						}));
					}
				},
				{
					title: "Start Training",
					name: "start-training",
					static: true,
					onRender: (e) => {
						const $this = $(e);
						const $clipboardButton 	= $(".js-clipboard-button");
						const $clipboardInput 	= $(".js-clipboard-input");
						const $mailtoLink 		= $(".js-mailto-link");

						if(!this.values.name) this.values.name = settings.name;
						if(!this.values.courseTitle) this.values.courseTitle = settings.courseTitle;
						if(!this.values.courseID) this.values.courseID = settings.courseID;
						if(!this.values.courseLink) this.values.courseLink = settings.courseLink;

						// Default to courses unless course link found
						let courseLink = this.values.courseLink;
						if(this.values.courseID) courseLink += this.values.courseID;
						if(courseLink){
							$this.find('.js-course-link').text(courseLink);
							$this.find('.js-link-button').attr("href", courseLink);
						}

						// Set staff name and course title
						if(this.values.name) $this.find('.js-name').text(this.values.name);
						if(this.values.courseTitle) $this.find('.js-course-title').text(this.values.courseTitle);

						// Show/Hide relevant text.
						if(this.values.courseID){
							$this.find(".js-courses-text").hide();
							$this.find(".js-course-text").show();
						}else {
							$this.find(".js-course-text").hide();
							$this.find(".js-courses-text").show();
						}

						const mainStartTrainingLink = document.querySelector('.js-start-training-link');
						const backLink = $this.find('.js-back-link');
						const isPageTeam = document.querySelector('.page-team');
						if (isPageTeam) {
							backLink.hide();
						} else {
							backLink.on('click', Igloo.$d(this, function($this){
								mainStartTrainingLink.click();
							}));
						}

						// Copy link to clipboard
						$clipboardButton.on('click', Igloo.$d(this, function($this){
							const clipboardText = $clipboardInput.text();
							if(clipboardText) this.copyTextToClipboard(clipboardText);
						}));

						// Email link subject and message
						const subject = encodeURIComponent(`Hackney Nights Course`);
						const message = encodeURIComponent(`You have been invited to complete a course on Hackney Nights.\n\nClick the link to take the course: ${courseLink}.`);
						const emailString = `mailto:?subject=${subject}&body=${message}`;
						$mailtoLink.attr('href', emailString);
					}
				},
			]
		}
		this.setup(settings);
	};
	StartTrainingPopup.inheritsFrom( PopupForm );

	/*
	 * Copy text to clipboard with fallback.
	 */
	StartTrainingPopup.prototype.copyTextToClipboard = function(text){
		if (!navigator.clipboard) {
			this.fallbackCopyTextToClipboard(text);
			return;
		}

		navigator.clipboard.writeText(text).then(function() {
			console.log('Async: Copying to clipboard was successful!');
		}, function(err) {
			console.error('Async: Could not copy text: ', err);
		});
	}
	StartTrainingPopup.prototype.fallbackCopyTextToClipboard = function(text){
		var textArea = document.createElement("textarea");
		textArea.value = text;

		// Avoid scrolling to bottom
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			var msg = successful ? 'successful' : 'unsuccessful';
			console.log('Fallback: Copying text command was ' + msg);
		} catch (err) {
			console.error('Fallback: Oops, unable to copy', err);
		}

		document.body.removeChild(textArea);
	}

